import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ConfirmationModal.css";
const ConfirmationModal = ({ isOpen, title, message, onConfirm, onCancel }) => {
  return (
    <Modal show={isOpen} onHide={onCancel} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="modal-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="text-muted">{message}</p>
      </Modal.Body>
      <Modal.Footer className="border-0 merit-confirm-footer">
        <Button
          type="button"
          variant="outline-secondary"
          className="merit-confirm-btn-nao"
          onClick={onCancel}
        >
          Não
        </Button>
        <Button
          type="button"
          variant="primary"
          className="merit-confirm-btn-sim"
          onClick={onConfirm}
        >
          Sim
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
